import sectionFields from 'molecules/Section/config';

import type { Component, Input } from '@builder.io/sdk';

/**
 * Below-the-fold two-column overview: rich text on the left, a checklist on the right.
 */
const eventOverviewFields = [
  {
    name: 'leftHeading',
    type: 'string',
    defaultValue: 'In this workshop',
    helperText: 'Heading for the left column.',
  },
  {
    name: 'leftBody',
    type: 'richText',
    helperText: 'Rich text body for the left column (supports multiple paragraphs).',
  },
  {
    name: 'rightHeading',
    type: 'string',
    defaultValue: 'What to expect',
    helperText: 'Heading for the right column.',
  },
  {
    name: 'items',
    type: 'list',
    helperText: 'Checkmark list items shown in the right column.',
    subFields: [
      {
        name: 'text',
        type: 'longText',
        required: true,
        helperText: 'Text for this checkmark item.',
      },
    ],
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const eventOverviewConfig = {
  name: 'EventOverview',
  inputs: eventOverviewFields,
} satisfies Component;

export type EventOverviewProps = GenerateBuilder<typeof eventOverviewFields>;

export default eventOverviewConfig;
